import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { firstValueFrom } from 'rxjs';

import { GuarnicaoStore } from '../../services/guarnicao.store';
import { GuarnicaoDialog } from '../guarnicao-dialog/guarnicao-dialog';
import { DIALOG_PRESETS } from '../../../../shared/utils/dialog-presets';
import { NxStatusBadge } from '../../../../shared/ui/status-badge/status-badge';
import { FuncaoGuarnicao, FuncaoGuarnicaoLabels } from '../../models/guarnicao.model';

@Component({
  selector: 'app-guarnicao-card',
  templateUrl: './guarnicao-card.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule, MatButtonModule, MatTooltipModule, NxStatusBadge],
})
export class GuarnicaoCard {
  private readonly dialog = inject(MatDialog);
  protected readonly store = inject(GuarnicaoStore);

  protected readonly viaturaPrefixo = computed(() => {
    const v = this.store.guarnicao()?.viatura;
    if (!v) return null;
    return v.prefixo || v.placa;
  });

  protected readonly policiais = computed(() => this.store.guarnicao()?.policiais ?? []);
  protected readonly totalPoliciais = this.store.totalPoliciais;
  protected readonly expirada = this.store.expirada;
  protected readonly guarnicaoValida = this.store.guarnicaoValida;
  protected readonly atualizadaEm = this.store.atualizadaEmFormatada;
  protected readonly origemGuarnicao = computed(() => this.store.guarnicao()?.origem ?? 'MANUAL');

  protected funcaoLabel(funcao: FuncaoGuarnicao): string {
    return FuncaoGuarnicaoLabels[funcao] ?? '';
  }

  async abrirDialog(): Promise<void> {
    const ref = this.dialog.open(GuarnicaoDialog, {
      ...DIALOG_PRESETS.formCompact,
      disableClose: false,
    });
    await firstValueFrom(ref.afterClosed());
  }
}
